<template>
  <section class="access-denied">
    <div
      class="background"
      :style="{ 'background-color': bgColor }"
    ></div>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="content-wrapper d-flex align-items-center justify-content-center auth theme-one"
        >
          <div class="row w-100">
            <div class="col-lg-4 mx-auto">
              <div class="auto-form-wrapper text-center">
                <div v-if="logoUrl" class="mb-3">
                  <img class="logo-img" :src="logoUrl" />
                </div>
                <h3 class="denied-title mb-4">{{ deniedTitle }}</h3>
                <p class="denied-message mt-2 text-center">
                  {{ deniedMessage }}
                </p>
                <div class="login-meta mt-5 text-center">
                  <p>登入 IP：{{ deniedLoginIp }}</p>
                  <p>登入時間：{{ deniedLoginTime }}</p>
                </div>
                <div class="mt-4">
                  <router-link class="back-login" :to="loginRoute">
                    返回登入頁
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('general', {
      organizationThemeConfig: (state) => state.organizationThemeConfig,
      accessDeniedPayload: (state) => state.accessDeniedPayload,
    }),
    bgColor() {
      return this.organizationThemeConfig?.auth?.bg_color ?? '#4c4c4c';
    },
    logoUrl() {
      return this.organizationThemeConfig?.auth?.logo_url ?? null;
    },
    deniedTitle() {
      return this.accessDeniedPayload?.title || '拒絕存取';
    },
    deniedMessage() {
      return this.accessDeniedPayload?.message || '您的 IP 被拒絕存取，請聯繫管理員';
    },
    deniedLoginIp() {
      return this.accessDeniedPayload?.login_ip || '-';
    },
    deniedLoginTime() {
      return this.accessDeniedPayload?.login_time || '-';
    },
    deniedReason() {
      return this.accessDeniedPayload?.reason || '';
    },
    loginRoute() {
      return {
        name: 'AuthLogin',
        params: { org_code: this.$route.params.org_code },
      };
    },
  },
  beforeDestroy() {
    this.$store.commit('general/CLEAR_ACCESS_DENIED_PAYLOAD');
  },
};
</script>

<style scoped lang="scss">
.background {
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.logo-img {
  width: 150px;
}
.denied-title {
  color: #666;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: 2px;
}
.denied-message {
  color: #666;
  font-size: 16px;
  line-height: 1.8;
  text-align: left;
}
.login-meta {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
}
.back-login {
  color: #2f70c9;
  font-size: 16px;
  text-decoration: underline;
}
</style>
